import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Avatar, Spacer, Text } from '@atomic';
import TimeText from './TimeText';

const PostCommentContainer = styled(Spacer)`
  display: flex;
  margin-bottom: 14px;
  align-items: center;
`;

const ContentWrapper = styled.div`
  display: inline-block;
`;

const avatarStyle = {
  display: 'inline-block',
};

const PostComment = ({ comment: initialState, ...props }) => {
  const { comment, author, createdAt } = initialState;
  const { image: avatarUrl, fullName: userName } = author;

  return (
    <PostCommentContainer as="li" spacerType="horizontal" size={4} {...props}>
      <Avatar style={avatarStyle} avatarUrl={avatarUrl} borderSize={35} />
      <ContentWrapper>
        <TimeText userName={userName} createdAt={createdAt} />
        <Text block textSize={18}>
          {comment}
        </Text>
      </ContentWrapper>
    </PostCommentContainer>
  );
};

PostComment.propTypes = {
  comment: PropTypes.shape({
    comment: PropTypes.string,
    author: PropTypes.shape({
      image: PropTypes.string,
      fullName: PropTypes.string,
    }),
    createdAt: PropTypes.string,
  }),
};

export default PostComment;
